import React from 'react'

import CompanyInfo from './CompanyInfo'
import CompanyAddress from './CompanyAddress'

import type { BranchAddressLoadingProps } from 'features/Branch'

const CompanyForm: React.FC<BranchAddressLoadingProps> = ({
  setAddressLoading,
}: BranchAddressLoadingProps): JSX.Element => {
  const base = 'f-company__form'

  return (
    <div className={base}>
      <CompanyInfo />
      <CompanyAddress setAddressLoading={setAddressLoading} />
    </div>
  )
}

export default CompanyForm
